export default __webpack_public_path__ + "files/4e8057cd6539f1927c7c20b9c160037a.svg";